// Centralized query keys. Every hook derives its key here so cache patches
// (setQueryData) and invalidations target the exact same tuples.
//
// These key tuples double as the documented read contract against serve-manager:
//   fleet                     -> GET /fleet
//   fleet.usage               -> GET /fleet/usage
//   site.status(id)           -> GET /sites/{id}/status
//   site.logs(id)             -> GET /sites/{id}/logs
//   site.logTail(id, channel) -> GET /sites/{id}/logs/{channel}
//   site.editorUsage(id)      -> GET /sites/{id}/editor-usage
//   site.editorKey(id)        -> GET /sites/{id}/editor  (Anthropic key status)
//   site.chats(id, session)   -> GET /sites/{id}/chats
//   site.usage(id)            -> GET /sites/{id}/usage
//   job(id)                   -> GET /jobs/{id}
//   jobs                      -> GET /jobs   (history list)
//   localKeys                 -> GET /store/keys
//   localConfigStatus         -> GET /store/local-config/status
//   fleetSettings             -> GET /store/settings  (names + set stamps, never values)

export const queryKeys = {
  fleet: ['fleet'] as const,
  fleetStatus: ['fleet', 'status'] as const,
  site: (siteId: string) => ['site', siteId] as const,
  siteStatus: (siteId: string) => ['site', siteId, 'status'] as const,
  siteLogs: (siteId: string) => ['site', siteId, 'logs'] as const,
  siteLogTail: (siteId: string, channel: string) =>
    ['site', siteId, 'logs', channel] as const,
  siteEditorUsage: (siteId: string) => ['site', siteId, 'editor-usage'] as const,
  siteEditorKey: (siteId: string) => ['site', siteId, 'editor-key'] as const,
  siteChats: (siteId: string, session?: string | null) =>
    ['site', siteId, 'chats', session ?? ''] as const,
  siteUsage: (siteId: string) => ['site', siteId, 'usage'] as const,
  job: (jobId: string) => ['job', jobId] as const,
  jobs: ['jobs'] as const,
  localKeys: ['store', 'keys'] as const,
  localConfigStatus: ['store', 'local-config', 'status'] as const,
  fleetSettings: ['store', 'settings'] as const,
} as const;
